import { channelRegistry } from './channelRegistry';

export default {
  install(app) {
    console.log('[ChannelExtensibility] Plugin installing...');
    
    // Registry já está exposto no window via channelRegistry.js
    // Este plugin apenas garante que está disponível
    
    if (!window.chatwoot?.channelRegistry) {
      console.error('[ChannelExtensibility] Failed to initialize registry');
      return;
    }

    console.log('[ChannelExtensibility] ✓ Channel registry available at window.chatwoot.channelRegistry');
    console.log('[ChannelExtensibility] API: register(config), getAll(), getByKey(key), getComponent(key)');
  }
};
